import { WifiOff } from 'lucide-react';

import { Banner, Icon } from '@crossnokaye/ux-common';

import { useCurrentAgentStatus } from '@/hooks/use-current-agent-status';

/**
 * A banner that appears when the current facility's agent reports offline status.
 *
 * Behavior:
 * - Appears when agent presence reports the current facility as offline
 * - Shows "Offline Mode" message with a "Learn More" link
 * - Auto-dismisses when agent comes back online
 */
export const OfflineBanner = () => {
  const { isOffline } = useCurrentAgentStatus();

  if (!isOffline) {
    return null;
  }

  return (
    <Banner variant="warning">
      <div className="flex items-center justify-center gap-3">
        <Icon icon={WifiOff} variant="rounded" backgroundColor="bg-ckds-base-black" />

        <span className="truncate text-ckds-base-black">
          <span className="font-bold">Offline Mode:</span> The facility agent is not connected to
          the cloud. You cannot monitor or control the facility.
        </span>
      </div>
    </Banner>
  );
};
